import { useCallback, useRef, useState } from "react";

import { makeGetApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { mapBarcodeHistoryProduct } from "./BarcodeHistoryProduct";

const emptyProduct = () => ({
  serial: null,
  on_hand_net_kg: null,
  statusReason: null,
  stock_unit_of_measurement: null,
  on_hand_piece_count: null,
  name: null,
  name_ch: null,
  created_date: null,
  barcode: null,
  barcode_histories: null,
  id: null,
  itemType: null,
});

export function BarcodeHistoryViewModel(logout) {
  const requestSequence = useRef(0);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(emptyProduct);

  const showErrorModal = useCallback((subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  }, []);

  const getBarcodeHistory = useCallback(async function (barcode) {
    const normalizedBarcode = String(barcode ?? "").trim();
    const requestId = ++requestSequence.current;

    if (normalizedBarcode.length === 0) {
      setProduct(emptyProduct());
      setLoading(false);
      showErrorModal("Barcode cannot be empty");
      return;
    }

    setProduct(emptyProduct());
    setLoading(true);

    try {
      const callResult = await makeGetApiCall(
        `barcodeHistory/${encodeURIComponent(normalizedBarcode)}`,
        {},
      );

      if (requestId !== requestSequence.current) return;

      if (callResult.success) {
        const nextProduct = mapBarcodeHistoryProduct(callResult.data);
        if (nextProduct) {
          setProduct(nextProduct);
        } else {
          showErrorModal("Barcode history response did not include item details");
        }
      } else {
        if (callResult.errorStatus === 401) logout();
        showErrorModal(callResult.data?.message ?? "Could not load barcode history");
      }
    } catch {
      if (requestId === requestSequence.current) {
        showErrorModal("Could not load barcode history");
      }
    } finally {
      if (requestId === requestSequence.current) setLoading(false);
    }
  }, [logout, showErrorModal]);

  // async function reprintLabel() {
  //   return axios.post("http://192.168.2.248:9100", {
  //     plu: "0108",
  //     name_en: "#1 Cull Slice XL (Bulk)",
  //     name_ch: "筛花皮参片(特大) 散装",
  //     lot_number: "2573647656",
  //     tare_weight: "10.2",
  //     best_before_date: "2025-05-19",
  //     piece_count: "100",
  //     weight_in_kg: "37.82KG",
  //     weight_in_lbs: "79.14LBS",
  //     barcode_str: "0154861755080851112507023102002000215679280005",
  //     label_image_zpl: "",
  //     is_sample: false,
  //     last_9: "000215679",
  //     sample: "",
  //   });
  // }

  const tsplCommand = `
SIZE 100 mm, 150 mm
CLS
TEXT 100,100,"TSS24.BF2",0,2,2,"Hello Vretti"
PRINT 1
`;

  async function reprintLabel() {
    await window.qz.websocket.connect();

    const config = window.qz.configs.create(null);
    config.host = "192.168.2.248";
    config.port = 9100;
    config.useSocket = true;

    await window.qz.print(config, [
      {
        type: "raw",
        format: "plain",
        data: tsplCommand,
      },
    ]);

    await window.qz.websocket.disconnect();
  }

  // const reprintLabel = async function () {
  //   let callResult = await makePostApiCallToPrinter({
  //     plu: "0108",
  //     name_en: "#1 Cull Slice XL (Bulk)",
  //     name_ch: "筛花皮参片(特大) 散装",
  //     lot_number: "2573647656",
  //     tare_weight: "10.2",
  //     best_before_date: "2025-05-19",
  //     piece_count: "100",
  //     weight_in_kg: "37.82KG",
  //     weight_in_lbs: "79.14LBS",
  //     barcode_str: "0154861755080851112507023102002000215679280005",
  //     label_image_zpl: "",
  //     is_sample: false,
  //     last_9: "000215679",
  //     sample: "",
  //   });

  //   if (callResult.success) {
  //   } else {
  //     if (callResult.errorStatus === 401) {
  //       logout();
  //     }
  //     showErrorModal(callResult.data.message);
  //   }
  // };

  return {
    product,
    getBarcodeHistory,
    loading,
    emptyModal,
    setEmptyModelOpen,
    reprintLabel,
  };
}
